import React from 'react';
import Drawer from '../../shared/ui/Drawer.js';
import FinanceUploadFlow from './FinanceUploadFlow.js';

interface FinanceUploadDrawerProps {
  open: boolean;
  onClose: () => void;
  onImported?: () => void;
}

/**
 * Finance upload drawer — accepts GF reports and weekly DSW only.
 * Daily DSW uploads are intentionally rejected here with a pointer to
 * Daily Entry, matching the product's workflow-ownership rule.
 */
export default function FinanceUploadDrawer({ open, onClose, onImported }: FinanceUploadDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose} title="Upload report" width={540}>
      <FinanceUploadFlow
        acceptedTypes={['gf_statement', 'service_worksheet', 'ispa_attachment_c1']}
        rejectMessage="This looks like a Daily Service Worksheet. Daily DSW uploads live under Daily Entry, not Finance. Close this and use Daily Entry → Upload daily DSW."
        onImported={onImported}
      />
    </Drawer>
  );
}
